import React, { useState, useEffect, useContext, useCallback } from 'react';
import { MyContext } from '../..';
import Alert from 'react-popup-alert'
import noProfileImage from '../../assets/images/user-3331257_640.webp'
import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: '100vw',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
}));

export default function UserProfile(props) {
  document.title = props.title;
  const queryParameters = new URLSearchParams(window.location.search)
  const username = queryParameters.get("username") || props.username
  const subscriberCode = queryParameters.get("subcode") || props.subCode
  const { backendUrl } = useContext(MyContext);
  const [formData, setFormData] = useState({
    username: username,
    subscriberCode: subscriberCode,
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    description: '',
    profileImage: null, // To store the selected file
  });
  const [alert, setAlert] = React.useState({
    type: 'error',
    text: 'This is a alert message',
    show: false
  })
  const [profileImage, setProfileImage] = useState();
  const classes = useStyles();
  const [userRoles, setUserRoles] = useState([]);
  const [roles, setRoles] = useState([]);

  const handleSelectorChange = (event) => {
    setUserRoles(event.target.value);
  };

  const fetchUserData = useCallback(async () => {
    try {
      const response = await fetch(`${backendUrl}/user/profile?username=${username}&subcode=${subscriberCode}`);
      if (response.ok) {
        const res = await response.json();
        // Update the form fields with the retrieved data
        setFormData({
          firstName: res.data.user.first_name || '',
          lastName: res.data.user.last_name || '',
          email: res.data.user.email || '',
          phoneNumber: res.data.user.phone_number || '',
          description: res.data.user.description || '',
          profileImage: res.data.user.profile_image_url || '',
          parentId: res.data.user.parent_id || '',
          username: username,
          subscriberCode: subscriberCode
        });
        setUserRoles(res.data.userRoles);
        setRoles(Object.values(res.data.roles));
        setProfileImage(res.data.user.profile_image_url)
      } else {
        console.error('Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  }, [backendUrl, username, subscriberCode]);

  useEffect(() => {
    // Fetch user data when the component mounts
    fetchUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'profileImage') {
      // Handle file input separately
      setFormData({ ...formData, profileImage: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Create a new FormData object
      const data = new FormData();

      // Append form data fields
      data.append('username', formData.username);
      data.append('firstName', formData.firstName);
      data.append('lastName', formData.lastName);
      data.append('email', formData.email);
      data.append('phoneNumber', formData.phoneNumber);
      data.append('description', formData.description);
      data.append('userRoles', userRoles);
      data.append('subscriberCode', subscriberCode);

      // Append the profile image file
      if (formData.profileImage) {
        data.append('profileImage', formData.profileImage);
      }

      // Send a POST request to your backend with the FormData
      const response = await fetch(`${backendUrl}/user/profile`, {
        method: 'PUT',
        body: data,
      });

      if (response.ok) {
        // Handle success
        console.log('Profile updated successfully');
        setAlert({
          type: 'success',
          text: 'Profile updated successfully',
          show: true
        })
      } else {
        // Handle errors
        console.error('Profile update failed');
      }
    } catch (error) {
      console.error('Error updating profile:', error);
    }
  };
  function onCloseAlert() {
    setAlert({
      type: '',
      text: '',
      show: false
    })
    fetchUserData();
  }
  return (
    <div className="container">
      <Alert
        header={'Message'}
        btnText={'Close'}
        text={alert.text}
        type={alert.type}
        show={alert.show}
        onClosePress={onCloseAlert}
        pressCloseOnOutsideClick={true}
        showBorderBottom={true}
        alertStyles={{}}
        headerStyles={{}}
        textStyles={{}}
        buttonStyles={{}}
      />
      <h1 style={{ textAlign: "center" }}>{formData.firstName} Profile</h1>
      <div className="upper-profile-box">
        <img src={profileImage ? profileImage : noProfileImage} alt="profileImage" className='profile-img' />
        <FormControl className={classes.formControl}>
          <InputLabel id="chip-multiselect-label">Roles</InputLabel>
          <Select
            labelId="chip-multiselect-label"
            id="chip-multiselect"
            multiple
            value={userRoles}
            onChange={handleSelectorChange}
            input={<Input id="select-multiple-chip" />}
            renderValue={(selected) => (
              <div className={classes.chips}>
                {selected.map((value) => (
                  <Chip key={value} label={value} className={classes.chip} />
                ))}
              </div>
            )}
          >
            {roles.map((role) => (
              <MenuItem key={role} value={role}>
                {role}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                type="number"
                className="form-control"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <input
                type="text"
                className="form-control"
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="profileImage">Profile Image</label>
              <input
                type="file"
                className="form-control"
                id="profileImage"
                name="profileImage"
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary mt-3">
          Update
        </button>
      </form>
    </div>
  );
}